export default (function (_a) {
    var zIndex = _a.zIndex;
    if (!zIndex)
        return;
    if (typeof zIndex !== "number")
        return;
    return "z-index: ".concat(zIndex, ";");
});
